import { months } from "../../../../Utils/months";

export const getNextMonth = (monthIndex) => {
    if (monthIndex === undefined || monthIndex === null) return;
    if (monthIndex === 11) {
        return 'enero';
    }
    return months[monthIndex + 1];
}

export const convertDataCurrency = (obj, monedaDestino, dollarExchange) => {
    let tasaCambio = 1;
    if (monedaDestino === "$") {
        tasaCambio = (1 / dollarExchange);
    } else if (monedaDestino === "Q") {
        tasaCambio = dollarExchange;
    }

    const recorrerObjeto = (obj) => {
        for (const key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                recorrerObjeto(obj[key]);
            } else if (
                key === 'CostoKgSec' && typeof obj[key] === 'number' && obj[key]
            ) {
                obj[key] *= tasaCambio;
            }
        }
        return obj;
    };

    return recorrerObjeto(obj);
};

